function initStickyInput(root) {
    const inputWrapper = root.$el.querySelector('.l-ss-c-search-top-section-wrapper');
    const scrollContainer = root.$el.querySelector('.l-ss-c-search-popup-wrapper-mask');

    let prevScrollTop = 0;
    let prevDirection = null;
    let isStickyInput = false;

    const setInputWrapperProperties = (inputWrapperHeight, reverse = false) => {
        let start = `-${inputWrapperHeight}px`;
        let end = '0px';

        if (reverse) {
            const tmp = start;
            start = end;
            end = tmp;
        }

        inputWrapper.style.setProperty('--start-top', start);
        inputWrapper.style.setProperty('--end-top', end);
    };

    const showInputWrapper = (filtersContainer, inputWrapperHeight) => {
        setInputWrapperProperties(inputWrapperHeight);

        if (filtersContainer) {
            filtersContainer.style.top = `${inputWrapperHeight - 2}px`;
        }

        inputWrapper.classList.add('l-ss-c-search-top-section-wrapper-sticky');

        prevDirection = 'top';
    };

    const hideInputWrapper = (filtersContainer, inputWrapperHeight) => {
        setInputWrapperProperties(inputWrapperHeight, true);

        if (filtersContainer) {
            filtersContainer.style.top = '0px';
        }

        prevDirection = 'bottom';
    };

    const onScroll = () => {
        const scrollTop = scrollContainer.scrollTop;
        const inputWrapperHeight = inputWrapper.clientHeight;
        const currentDirection = scrollTop < prevScrollTop ? 'top' : 'bottom';

        const filtersContainer = scrollContainer.querySelector('.l-ss-c-filters-container');
        const filtersContainerTop = filtersContainer?.getBoundingClientRect().top || 0;

        if (prevDirection === 'bottom' && currentDirection === 'top' && filtersContainerTop === 0) {
            showInputWrapper(filtersContainer, inputWrapperHeight);
            isStickyInput = true;
        } else if (prevDirection === 'top' && currentDirection === 'bottom' && isStickyInput) {
            hideInputWrapper(filtersContainer, inputWrapperHeight);
            isStickyInput = false;
        }

        prevDirection = currentDirection;
        prevScrollTop = scrollTop;
    };

    scrollContainer.addEventListener('scroll', onScroll);
}

export default function useStickyInput(root) {
    setTimeout(() => {
        initStickyInput(root);
    });
}
